/* Copyright 2013 - 2022 Waiterio LLC */
/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import AppBar from '@stiloso/components/AppBar.js'
import AppBarTitle from '@stiloso/components/AppBarTitle.js'
import { useTranslation } from '@multilocale/react/index.js'
import Layout from '../components/Layout.js'
import useLoggedInSession from '../session/useLoggedInSession.js'

export const paths = ['/clients/:clientName/credentials']

const CredentialsPage = () => {
  const { t } = useTranslation()
  useLoggedInSession()

  return (
    <Layout>
      <div css={{ margin: '32px auto', maxWidth: 640, width: '100%' }}>
        <AppBar>
          <AppBarTitle>{t('Credentials')}</AppBarTitle>
          <div css={{ flexGrow: 1 }} />
        </AppBar>
      </div>
    </Layout>
  )
}

export default CredentialsPage
